export enum PostType {
  Image = 'image',
  Video = 'video',
}
